import RenameDocumentDialog from './RenameDocumentDialog';

export default RenameDocumentDialog;
